import React, { forwardRef, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useApplicationState } from '@atlas/core';
import { HeaderTerminalLayout } from '@atlas/ui';

import HeaderInfo from 'components/Layout/Header/HeaderInfo';
import HeaderLogoItem from 'components/Layout/Header/HeaderLogoItem';

const Header = ({ depositBtnLink, isIgnoredUnreadMessages, logoutRedirectLink, ref }) => {
  const { push: historyPush } = useHistory();
  const { authenticated } = useApplicationState();
  const { search } = useLocation();

  const customSignUpBtnCb = useCallback(() => {
    historyPush('?cmd=signup');
  }, [historyPush]);

  const accountDropdownTabs = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    searchParams.set('cmd', 'withdrawal');
    return [
      {
        customLink: `?${searchParams}`,
        icon: 'wallet-icon',
        name: 'withdrawal',
        type: 'general',
      },
    ];
  }, [search]);

  return (
    <HeaderTerminalLayout className="header-terminal" ref={ref}>
      <HeaderTerminalLayout.Logo>
        <HeaderLogoItem redirectTo="/" />
      </HeaderTerminalLayout.Logo>
      <HeaderTerminalLayout.Content className={cx({ authorized: authenticated })}>
        <HeaderInfo
          accountDropdownTabs={accountDropdownTabs}
          customSignUpBtnCb={customSignUpBtnCb}
          depositBtnLink={depositBtnLink}
          isIgnoredUnreadMessages={isIgnoredUnreadMessages}
          isTerminal
          logoutPopupType="terminalLogout"
          logoutRedirectLink={logoutRedirectLink}
        />
      </HeaderTerminalLayout.Content>
    </HeaderTerminalLayout>
  );
};

Header.propTypes = {
  depositBtnLink: PropTypes.string,
  isIgnoredUnreadMessages: PropTypes.bool,
  logoutRedirectLink: PropTypes.func,
  ref: PropTypes.func,
};

export default forwardRef(Header);
